export default __webpack_public_path__ + "50427390ecba9ffb0ae8938b1516885d.png";